import { getString, setString } from './local-storage/interface-base';
import { reload } from './webview/webview';
import dateLangZhCN from 'antd/es/date-picker/locale/zh_CN';
dateLangZhCN.lang.monthFormat = 'M月';
dateLangZhCN.lang.shortWeekDays = '日_一_二_三_四_五_六'.split('_');

const KEY = 'ingame_language';

export enum LanguageType {
  'zh_CN' = 'zh_CN',
  'en_US' = 'en_US',
}

export function setLocaleLanguage(value: LanguageType) {
  setString(KEY, value);
}

export function getLocaleLanguage(): LanguageType | null {
  return getString(KEY);
}

Object.assign(window, {
  __setLanguage: (value: LanguageType) => {
    setLocaleLanguage(value || LanguageType.en_US);
    reload();
  },
});
